<ng-container *rxLet="loading$ as loading">
  <button
    nz-button
    [nzSize]="'large'"
    [nzBlock]="fullSize"
    [nzLoading]="loading"
    [disabled]="loading"
    (click)="openCreateUserRequestModal()"
  >
    {{ 'USER_REQUESTS.LOT_TRANSLATE_REQUEST' | translate }}
  </button>
</ng-container>
